import React, {PropTypes} from 'react';
import ClassNames from 'classnames';
import './style.scss';

const Chip = ({status}) => (
    status ? <div className={ClassNames("visit__status", `status-${status.toLowerCase()}`)}><div className="chip">{status}</div></div> : <div />
);

Chip.propTypes = {
    status: PropTypes.string
};

export default Chip;